// Design tokens for the agents + reconcile features (the CSG palette since 2026-09-25).
//
// Since 2026-09-24 (dashboard-wide Claude palette, spec §5) BOTH export names
// point at the SAME object: colours are `var(--odin-…)` strings that resolve
// through the variables ClaudeVars sets on <html>, so every agent surface
// follows the header toggle instead of being pinned dark. Nothing under
// features/agents or features/reconcile had to change for that — the key
// names are the ones those 66 files already use.
//
// Exceptions, on purpose:
//  - radii and fonts stay literal (mode-independent). Everything else, the
//    accent included, is a var(): the accent is Oxford Blue in light and
//    Celestial in dark, so alpha tints are color-mix() at the call site.
//  - `textMuted` is the agents' name for `--odin-text-tertiary`.
//  - `accentText` is the accent read as TEXT (kickers, links): the AA stop
//    `--odin-accent-text` (Lapis Lazuli in light). `accent` is for fills only;
//    `highlight` (Celestial in both modes) is for thin glyphs and bars.
//  - `ink`, `chrome`, `highlight`, `info.*` and `shadow.*` arrive through the VARS spread.
import { SCALE, VARS } from '../../theme/claudeTokens';

const tokens = {
  ...VARS,
  textMuted: VARS.textTertiary,
  accentText: 'var(--odin-accent-text)',
  radiusSm: SCALE.radiusSm,
  radiusMd: SCALE.radiusMd,
  radiusLg: SCALE.radiusLg,
  radiusXl: SCALE.radiusXl,
  fontSans: SCALE.fontSans,
  fontDisplay: SCALE.fontDisplay,
  fontMono: SCALE.fontMono,
};

export const claude = tokens;
export const claudeDark = tokens;
